import { useMemo } from 'react';

import { Text } from '@chakra-ui/react';

import { dateHelpers } from '@nocowanie/core';
import { usePluralisationTranslation } from '@nocowanie/common-ui';

import { getDates } from '@app/helpers/accommodation.helpers';
import { accommodationSlice, useAppSelector } from '@app/state';

import { GuestsNightsLabelProps } from './guests-nights-label.props';

export const GuestsNightsLabel = ({
    adultsCount,
    childrenCount,
    nightsCount,
    ...props
}: GuestsNightsLabelProps) => {
    const pluralizeTranslation = usePluralisationTranslation('accommodation', 'guestsNightsLabel');

    const filters = useAppSelector(accommodationSlice.selectors.selectFilters);

    const { checkIn, checkOut } = filters ?? {};

    const dates = getDates(checkIn ?? new Date(), checkOut ?? new Date());
    const nights = useMemo(
        () =>
            filters
                ? Math.max(1, dateHelpers.daysDateDiff(dates[0], dates[1]))
                : (nightsCount as number),
        [dates, filters, nightsCount],
    );

    const nightsLabel = pluralizeTranslation(nights, 'night');
    const valueToPluralize = childrenCount > 0 ? childrenCount : adultsCount;
    const totalGuestsLabel = pluralizeTranslation(
        valueToPluralize,
        'person',
        `${adultsCount}${childrenCount ? ` + ${childrenCount}` : ''}`,
    );

    return (
        <Text as={'span'} whiteSpace={'nowrap'} fontSize={'xs'} {...props}>
            {totalGuestsLabel}, {nightsLabel}
        </Text>
    );
};
